<template>
	<div>
		<div class="top-header"> 
			<div class="flex">
				<div class="djk-logo"></div>
				<div class="header-logo">
				</div>
				<ul class="header-nav">
					<li v-for="item in headerNav" :key="item.type">
						<span :class='changeflag==item.type?"active":""'  @click='nav_click(item)' >{{item.value}}</span>
					</li>
				</ul>
				
			</div>
			<div class="flex">
				<div class="old-version-entry" @click="oldVersionEntry">旧版入口</div>
				<div class="header-btn" v-if='!userName'>
					<div >
						<!-- <span @click="userLogin(1)">个人登录</span ><b>|</b><span @click="userLogin(2)">机构登录</span> -->
						
						<div v-if="institutionName">欢迎您：{{ institutionName }}</div>
					</div>
					<!-- @click="sign_click" -->
					<div  class="btn-sign" @click="userLogin(1)">登录/注册</div>  
				</div>
				<div class="header-btn" v-else>
					<div class="header-info" >
						<div>{{userName}}</div>
						<div v-if="institutionName">[{{ institutionName }}]</div>
						<el-dropdown>
							<span class="el-dropdown-link">
								积分<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-if="personalScore!=''||personalScore==0">个人积分：{{personalScore}}</el-dropdown-item>
								<el-dropdown-item  v-if="institutionalScore!=''||institutionalScore==0">机构积分：{{institutionalScore}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<el-dropdown>
							<span class="el-dropdown-link">
								到期时间<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown"> 
								<el-dropdown-item v-if="personalEndDate">个人到期时间：{{personalEndDate}}</el-dropdown-item>
								<el-dropdown-item v-if="institutionEndDate">机构到期时间：{{institutionEndDate}}</el-dropdown-item> 
							</el-dropdown-menu>
						</el-dropdown> 
					</div> 
					<div  class="btn-sign"  @click="exit">退出</div> 
				</div>
			</div>
			<userSign :show.sync='isShowSign' v-if='isShowSign'></userSign>
		</div>
		<modelTip :ok="'确定'"   :show.sync='isShowTip' @ok='sureTip' :width="'300px'" :title="'提示'">
            <div slot="content" >
                该账号已被封禁，请联系管理员！
            </div>
        </modelTip>
	</div>
</template>

<script>
import Cookies from 'js-cookie'
import modelTip from './ui-kit/model_tip.vue';
import getRequest from '../utils/getRequest.js';
import { mapState, mapMutations, mapActions } from "vuex";
import{logout,getUsetInfo,login} from '../io/api.js'
import userSign from './user_sign.vue'
import {clearAllCookie} from '../io/getCookie.js'
export default {
	components: {
		userSign,
		modelTip
	},
	data() {
		return { 
			isShowTip:false,
			isShowSign:false,
			// userName: "登录",
			pedding: "", 
			headerNav:[
				{
					value:'首页',  
					type:1,
					path:'/homePage',
					id:'nav'
				},
				{
					value:'知识应用',
					type:2,
					id:'knowledge',
					path:'/'
				},
                // {
                //     value:'疾病画像',
				// 	type:9,
				// 	id:'disease',
				// 	path:'/'
                // },
				{
					value:'学习专区',
					type:3,
					id:'study',
					path:'/'
				},
				// {
				// 	value:'专题服务',
				// 	type:4,
				// 	id:'subject',
				// 	path:'/'
				// },
				{
					value:'热点新闻',
					type:5,
					id:'hotNews',
					path:'/hotNewsList'
				},
				{
					value:'特色资源',
					type:6,
					id:'resource',
					path:'/'
				},
                {
                    value:'古籍定制',
                    type:8,
                    id:'ancientBooks',
                    path:'/'
                },
				{
					value:'学科定制',
					type:7,
					id:'customization',
					path:'/'
				}
			], 
		};
	},
	computed: {
		...mapState(['changeflag','httpUrl','personalScore','institutionalScore','institutionName', 'userName', 'personalEndDate','institutionEndDate'])	
	},
	mounted() {
        //
        let urlFlag=getRequest(window.location.href)['changeflag']||''
        let changeflag = urlFlag?urlFlag:1
		this.$store.state.changeflag = changeflag; 
		// console.log(this.$route.query.changeflag,'=this.$route.query.changeflag')
		this.init();
		 
	},
	methods: { 
		...mapMutations(['medicalInit','initTableInfo','setHeaderInfo']),
		async userLogin(loginType) {
			this.clearAll();
            //loginType   1：个人  2：机构  3：h5  
			await login({loginType}).then(res=>{
				let data = res.data;
				if (data && data.code == 0) {
					window.open(data.data, "_self");
				}else{
					this.$message.error(data.msg);
				}
			}) 
		},
        oldVersionEntry(){
            window.open('https://www.tcmkb.cn/tcmkb/pages/home_index.jsp', "_blank");
        },
		//清空cookies 和 localStorage
		clearAll() {
			window.localStorage.clear();
			window.sessionStorage.clear();
			clearAllCookie();
			// console.log('所有的Cookies已被清除');
		},
		sign_click(){
			this.isShowSign=true;
			this.exit();
		},
		exit() {
			let token =  localStorage.getItem('token') || (Cookies.get("token")?Cookies.get("token"):''); 
			window.localStorage.removeItem('refresh_token')
			this.clearAll();	
			logout().then(res=>{ 
				let data = res.data;
				if(data&&data.code==0){ 
					window.open(`${window.location.origin}/knowservePlatform/homePage`, "_self");	
				}else{
					this.$message.error(data.msg);
				}
			})
		},
		async init() { 
			await getUsetInfo().then(res=>{ 
				let data = res.data;
				if (data && data.code == 0) { 
                    if(data.data){
						if(data.data.status==1){
							this.isShowTip=true;
							return
						} 
						this.setHeaderInfo(data.data) 
						window.localStorage.setItem("userName", this.userName);
						Cookies.set("userName", this.userName) 
                    }else{ 
						this.$store.state.userName = "";
						window.localStorage.setItem("userName", '');
						Cookies.set("userName", '')
						this.setHeaderInfo()
                    }
				} else if(data.code=='1001'){ 
					this.setHeaderInfo(data.data)
				} else {
					// this.$store.state.userName = "登录";
					this.setHeaderInfo()
				}

			}) 
		},
		//账号异常确定
		sureTip(){
			this.isShowTip=false;
			this.exit()
		},
		nav_click(item){   
			this.$store.state.changeflag =item.type;
			if(item.id){
				localStorage.setItem("toId", item.id); 
			}
			// if(this.$route.path == '/'||this.$route.path == '/homePage'){
			// 	this.$store.state.changeflag =1 
            //     if(item.id){
            //         this.$emit('getlocal', item.id)
            //     }
            // } 
			// if(this.$route.path === '/homePage'){
			// 	if(item.id){
			// 		this.$emit('getlocal', item.id)
			// 	}
			// }else{
				if(item.path!=''){
                    if(this.$route.path == '/'||this.$route.path == '/homePage'){  
	                    if(item.id){
                            this.$emit('getlocal', item.id)
                        }
                    }else{
                        let url = this.$router.resolve({
                            path:item.path,  
                            query:{
                                changeflag:this.$store.state.changeflag
                            }
                        })  
                        window.open(url.href, '_blank')  
                    }
					
				}
			// } 
			 

		},
	},
};
</script>
<style lang="less" scoped>
.top-header{
	.flex{
		display: flex;
		align-items: center; 
	}
	height: 70px;
	background: #fff;
	width: 100%;
	min-width: 1200px; 
	padding-left: 10px;
	.flex();
	justify-content: space-between;
	border-bottom: 2px solid;
	border-image: linear-gradient(to right, rgb(65, 233, 118), #396de7) 1;
	.djk-logo{
		width: 50px;
		height: 50px;
		background: url('../assets/images/home/djk-logo.png') no-repeat;
		background-size:contain;
	}
	.header-logo{
		width: 166px;
		height: 30px;
		background: url('../assets/images/logoHeader.png') no-repeat;
		background-size:contain;
		margin-right: 20px;
	}
	.header-nav{
		.flex();
		justify-content: space-between;
		width: 680px;
		font-size: 16px;
		span{
			cursor: pointer;
		}
		.active{
			color:#396de7;
		}
		// li{
		// 	flex-shrink: 1
		// }
	}
    .old-version-entry{ 
        cursor: pointer;
    }
	.header-btn{
		.flex();
		text-align: center;
		height: 100%;
		div{
			// padding:0 44px;
			height: 100%;
			line-height: 70px;
			margin-left: 8px;
			// width: 80px;
			span{
				padding:10px;
				cursor: pointer;
			}
		}
		.btn-sign{
			cursor: pointer;
		}
		.header-info{
			display: flex;
			justify-content: space-evenly;
			// width: 400px;
		}
		.btn-sign{
			width: 128px;
			background: #396de7;
			color: #fff;
		}
	}
}
</style>
